/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {AvalancheWinInfo} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {GSAPUtils} from "../utils/GSAPUtils";
import {gsap} from "gsap";
import {KitchenDramaSushiManiaGameMode} from "../server/KitchenDramaSushiManiaGameMode";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";
import {KitchenDramaSushiManiaStatics} from "../utils/KitchenDramaSushiManiaStatics";
import {WinSize} from "../view/KitchenDramaSushiManiaWinView";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";

export class WinAndRemovePresentation implements SimplePresentation {
    name: string = "WinAndRemovePresentation";
    private roundIndex: number;
    private winInfo: AvalancheWinInfo;

    constructor(index: number) {
        this.roundIndex = index;
    }

    shouldRun(): boolean {
        this.winInfo = KitchenDramaSushiMania.model.gameData.avalancheWinInfo[this.roundIndex];
        return (this.winInfo.avalancheWin > 0);
    }

    start(controller: SimplePresentationRunnerController): void {
        let wasSkipped = false;
        const betLineWinData = KitchenDramaSushiMania.model.gameData.betLineWins[this.roundIndex];
        const winMatrix = KitchenDramaSushiMania.model.createWinMatrix(betLineWinData);

        const winPositions = winMatrix.getAllCoordinatesForValue(KitchenDramaSushiManiaSymbolStates.WIN);
        const noWinPositions = winMatrix.getAllCoordinatesForValue(KitchenDramaSushiManiaSymbolStates.NO_WIN);

        let winSize = KitchenDramaSushiManiaStatics.getWinType(this.winInfo.avalancheWin);
        const isBigWIn = winSize == WinSize.big || winSize == WinSize.mega || winSize == WinSize.superMega;


        const isFastSpin = KitchenDramaSushiMania.apiPlugin.settings.get(APISetting.FAST_SPIN, false);

        const accumulatedRoundWin = this.winInfo.clientAccumulatedWin || this.winInfo.avalancheWin;
        const isBelowStake = KitchenDramaSushiMania.isWinBelowStake(accumulatedRoundWin)
        if (isBelowStake) {
            winSize = WinSize.none;
        }


        let containsMidsOrHighs: boolean = false;
        let containsLows: boolean = false;
        const jumpUpAnimations = [];
        const sliceAnimations = [];
        const fallDownAnimations = [];
        const noWin = [];
        const normal = [];

        const winAmountAnimations = [];

        for (let winLine of betLineWinData) {
            const reelPos = new PIXI.Point(
                winLine.nrOfSymbols - 1,
                KitchenDramaSushiMania.model.betLines[winLine.betLine][winLine.nrOfSymbols - 1]
            );
            winAmountAnimations.push(KitchenDramaSushiMania.winView.addBetLineWinFloater(winLine.amount, reelPos));
        }

        for (let winPos of winPositions) {
            const symbolData = KitchenDramaSushiMania.reelView.getVisibleSymbolDataAt(winPos.column, winPos.row);
            symbolData.removed = true;

            if (!containsMidsOrHighs) {
                containsMidsOrHighs = KitchenDramaSushiManiaStatics.LOW_SYMBOLS.indexOf(symbolData.name) < 0;
            }
            if (!containsLows) {
                containsLows = KitchenDramaSushiManiaStatics.LOW_SYMBOLS.indexOf(symbolData.name) >= 0;
            }

            jumpUpAnimations.push((<KitchenDramaSushiManiaSymbol>symbolData.positionable).playWin());
            sliceAnimations.push((<KitchenDramaSushiManiaSymbol>symbolData.positionable).playSliceAnimation(() => {
                return wasSkipped;
            }));
            fallDownAnimations.push((<KitchenDramaSushiManiaSymbol>symbolData.positionable).playFallDown());
        }

        for(let noWinPos of noWinPositions){
            const symbolData = KitchenDramaSushiMania.reelView.getVisibleSymbolDataAt(noWinPos.column,noWinPos.row);
            noWin.push((<KitchenDramaSushiManiaSymbol>symbolData.positionable).noWin());
            normal.push(()=>{(<KitchenDramaSushiManiaSymbol>symbolData.positionable).backToNormal()});
        }

        const jumpTl = GSAPUtils.createTimelineFromArray(jumpUpAnimations, "<0.0");
        const noWinTl = GSAPUtils.createTimelineFromArray(noWin, "<0.0");
        const sliceTl = GSAPUtils.createTimelineFromArray(sliceAnimations, isFastSpin ? "<0.03" : "<0.07");
        const fallDownTl = GSAPUtils.createTimelineFromArray(fallDownAnimations, "<0.02");
        const winAmountTL = GSAPUtils.createTimelineFromArray(winAmountAnimations, "<0.1");
        const normalTl = GSAPUtils.createTimelineFromArray(normal, "<0.0");


        //Add sound triggers
        if (!isBelowStake) {
            jumpTl.add(() => {
                KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.JUMP_LOW)
            }, 0.4)

            if (containsLows) {
                fallDownTl.add(() => {
                    KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.LOW_WIN_CHARACTERS_FALLING_DOWN)
                }, 0.7)
            }
            if (containsMidsOrHighs) {
                fallDownTl.add(() => {
                    KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.MEDIUM_WIN_CHARACTERS_FALLING_DOWN)
                }, 0.9)
                jumpTl.add(() => {
                    KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.JUMP_MID.next())
                }, 0.4)
            }
        }


        //Assembly
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(() => controller.setSkipCallback(() => {
            wasSkipped = true;
            tl.seek("ending", false);
        }), 0);

        tl.add([jumpTl,noWinTl]);
        tl.add([
            sliceTl,
            winAmountTL
        ], "<0.4");
        tl.add(fallDownTl, "<0.4");
        tl.add(normalTl);


        tl.add(KitchenDramaSushiMania.winView.getBuildUpAnimation(winSize), winAmountTL.endTime());

        if (isBigWIn) {
            const finalLevel = this.calculateBigWinLevel();
            let countUpValues = this.calculateCountUpValuesForLevels(finalLevel);
            tl.add(() => {
                KitchenDramaSushiMania.winView.getExplosionAnimation(this.winInfo.avalancheWin, winSize, false);
                KitchenDramaSushiMania.soundPlayer.playWinSound(winSize);
                KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.BLOB_SUCK);
            });
            tl.add(KitchenDramaSushiMania.bigWinView.getBigWinIntroAnimation(), "-=0.12");
            tl.add(KitchenDramaSushiMania.bigWinView.getBigWinAnimationForLevel(finalLevel, countUpValues));
            tl.addLabel("ending");
            tl.add(() => controller.setSkipCallback());
            tl.add(() => {
                if (wasSkipped) {
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.BIG_WIN_SMALL);
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.BIG_WIN_MEDIUM);
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.BIG_WIN_LARGE);
                }
            });
            tl.add(KitchenDramaSushiMania.bigWinView.getBigWinEnd());


        } else {
            tl.addLabel("ending");
            tl.add(() => controller.setSkipCallback());
            tl.add(() => {
                if (wasSkipped) {
                    //Stop sounds
                    KitchenDramaSushiMania.winView.clearFloaters();
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.MEDIUM_SLICE_SOUNDS.current());
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.LOW_SLICE_SOUNDS.current());
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.MEDIUM_WIN_CHARACTERS_FALLING_DOWN);
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.LOW_WIN_CHARACTERS_FALLING_DOWN);

                }
            });

            tl.add([
                () => {
                    KitchenDramaSushiMania.soundPlayer.playWinSound(winSize)
                },
                () => {
                    KitchenDramaSushiMania.soundPlayer.stopSound(KitchenDramaSushiManiaSound.BLOB_SUCK)
                },
                KitchenDramaSushiMania.winView.getExplosionAnimation(this.winInfo.avalancheWin, winSize, true)
            ]);

        }
        if (KitchenDramaSushiMania.model.data.mode == KitchenDramaSushiManiaGameMode.WILD_SUSHI || this.roundIndex > 0) {
            tl.add(() => {
                (<SlotKeypad>KitchenDramaSushiMania.keypadPlugin).setWinLegacy(accumulatedRoundWin, true, isBelowStake);
            });
        } else {
            tl.add(() => {
                (<SlotKeypad>KitchenDramaSushiMania.keypadPlugin).setWinLegacy(accumulatedRoundWin, true, isBelowStake);
            });
        }


        if (winSize == WinSize.none || (winSize == WinSize.tiny && isFastSpin)) {
            controller.setSkipCallback();
            wasSkipped = true;
            tl.add(() => {
                tl.seek("ending", false);
            }, 0.2)

        }


    }

    private calculateCountUpValuesForLevels(finalLevel: number): [number, number][] {
        let levels: [number, number][] = [];

        const playedBetValue = KitchenDramaSushiMania.model.gameData.playedBetValue;
        const winRatios = [15, 25, 50];

        for (let i: number = 0; i < winRatios.length; i++) {
            let startValue: number = i === 0 ? 0 : playedBetValue * winRatios[i];
            let toValue: number = i === finalLevel ? this.winInfo.avalancheWin : playedBetValue * winRatios[i + 1];
            levels.push([startValue, toValue]);
        }

        return levels;
    }

    private calculateBigWinLevel(): number {
        let level: number = 0;
        const currentWinRatio = this.winInfo.avalancheWin / KitchenDramaSushiMania.model.gameData.playedBetValue;
        const winRatios = [15, 25, 50];
        for (let i: number = 0; i < winRatios.length; i++) {
            if (currentWinRatio > winRatios[i]) {
                level = i;
            }
        }

        return level;
    }


}